import { lazy } from 'react'
import suspenseComponent from 'client/util/suspenseComponent'

// Containers
import NotesMenuContainer from 'client/containers/dashboard/Notes/containers/NotesMenuContainer'

// Components
const NotesListPage = lazy(() => import('client/containers/dashboard/Notes/pages/NotesListPage'))


const NotesMenuRoutes = [
  {
    path: '/:username/notes/:attributes_path',
    component: NotesMenuContainer,
    routes: [
      {
        path: '/:username/notes/:attributes_path',
        exact: true,
        auth: { reqAuthBiz: true, reqExpDate: true },
        params: { status: 'open', title: 'บันทึก', icon: 'assignment_late' },
        component: suspenseComponent(NotesListPage)
      },
      {
        path: '/:username/notes/:attributes_path/open',
        exact: true,
        auth: { reqAuthBiz: true, reqExpDate: true },
        params: { status: 'open', title: 'บันทึก', icon: 'assignment_late' },
        component: suspenseComponent(NotesListPage)
      },
      {
        path: '/:username/notes/:attributes_path/close',
        exact: true,
        auth: { reqAuthBiz: true, reqExpDate: true },
        params: { status: 'close', title: 'บันทึก', icon: 'assignment_late' },
        component: suspenseComponent(NotesListPage)
      },
      {
        path: '/:username/notes/:attributes_path/trash',
        exact: true,
        auth: { reqAuthBiz: true, reqExpDate: true },
        params: { status: 'trash', title: 'บันทึก', icon: 'assignment_late' },
        component: suspenseComponent(NotesListPage)
      }
    ]
  }
]

export default NotesMenuRoutes
